export const environment = {
  production: true,
  apiBaseUrl: 'https://api.npr.centurycodes.ng/api/v1',
  authUrl: 'https://auth.npr.centurycodes.ng',
};
